var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-img',{style:({top: 'calc(' + _vm.top + 'vh - 128px)', left: 'calc(' + _vm.left + 'vw - 128px)'}),attrs:{"id":"slime","src":_vm.requireSlimeTypeImgSrc(_vm.type)},on:{"click":_vm.collectSlime}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }